export default __webpack_public_path__ + "static/STICKER HR-24455ef43bce5ec93da452e4934e9172.svg";